<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-toska">
    <div class="container-fluid">
      <a class="navbar-brand" href="/">
        <i class="bi bi-building"></i> Standar Pelayanan - UOBK. Rumah Sakit Mata
      </a>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <a class="nav-link" href="https://rsm.kaltimprov.go.id/" target="_blank"><i class="bi bi-globe"></i></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://www.instagram.com/rsmprovkaltim/?hl=en" target="_blank"><i class="bi bi-instagram"></i></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="tel:05415800800"><i class="bi bi-telephone"></i> 0541-5800800</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'HeaderComponent'
}
</script>

<style scoped>
.bg-toska {
  background-color: #52B6BA;
}
.navbar-brand {
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
  max-width: none;
}

@media (max-width: 768px) {
  .navbar-brand {
    max-width: none;
    font-size: 0.9rem;
  }
  .nav-link {
    font-size: 0.9rem;
  }
  .navbar-toggler {
    display: none;
  }
}
</style>